<template>
  <div class='LinkCateg' @click="push">
    {{ data.name }}
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'LinkCateg',
  props: ['data'],
  methods: {
    ...mapActions(['changeFilterProdStore', 'GetStoreProducts']),
    push () {
      this.changeFilterProdStore({ categoria: this.data.name })
        .then(() => {
          this.GetStoreProducts({ params: { last: [], limit: 8, categoria: this.data.name }, init: true })
            .then(() => {
                this.$router.push('/loja')
              })
        })
    }
  }
}
</script>

<style scoped>
.LinkCateg {
  background-color: #EEEEEE;
  border: thin solid #CCCCCC;
  padding: 4px;
  border-radius: 10px;
  cursor: pointer;
  margin: 4px;
}
</style>
